/**
 * Euros without decimals and always with the Spanish thousands separator
 * ("3.000 €"). Intl's es-ES locale leaves 4-digit numbers ungrouped ("3000"),
 * which reads badly in amount columns.
 */
export const formatEuros = (amount?: number | string | null): string => {
  if (amount == null || amount === "") return "—";
  const rounded = Math.round(Number(amount));
  const sign = rounded < 0 ? "−" : "";
  const digits = String(Math.abs(rounded)).replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ".",
  );
  return `${sign}${digits} €`;
};
